import React from 'react';

const TypingIndicator: React.FC = () => {
  return (
    <div className="typing-indicator inline-flex items-center bg-primary-50 px-4 py-2.5 rounded-xl border border-primary-100 shadow-sm">
      <div className="flex items-center">
        <div className="mr-2 text-xs text-primary-600 font-medium">BYNN is typing</div>
        <div className="flex space-x-1">
          <div 
            className="h-2 w-2 bg-primary-400 rounded-full animate-bounce" 
            style={{ animationDelay: '0ms', animationDuration: '0.6s' }}
          ></div>
          <div 
            className="h-2 w-2 bg-primary-500 rounded-full animate-bounce" 
            style={{ animationDelay: '200ms', animationDuration: '0.6s' }}
          ></div>
          <div 
            className="h-2 w-2 bg-primary-600 rounded-full animate-bounce" 
            style={{ animationDelay: '400ms', animationDuration: '0.6s' }}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default TypingIndicator;